/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getKnowledgeDocDetail } from '@/api';
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import { Base64 } from 'js-base64';
import DOMPurify from 'dompurify';
export default {
  name: 'DOCDetail',
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  components: {
    XButton: XButton
  },
  data: function data() {
    return {
      info: {
        name: '',
        update_name: '',
        update_time: '',
        content: '',
        fileUrl: ''
      }
    };
  },
  computed: {
    urlList: function urlList() {
      var _this = this;
      var arr = this.info.fileUrl ? this.info.fileUrl.split(',') : [];
      return arr.map(function (url) {
        return _this.previewUrl(url);
      });
    },
    decodeHtml: function decodeHtml() {
      return this.$decodeHtml(DOMPurify.sanitize(this.info.content));
    }
  },
  methods: {
    showName: function showName(item) {
      var value = item.slice(item.lastIndexOf('/') + 1);
      return /\d+-.+/.test(value) ? value.split('-').slice(1).join('-') : value;
    },
    previewUrl: function previewUrl(url) {
      var preview = 'https://preview2.zhongyifu.cn/onlinePreview';
      return "".concat(preview, "?url=").concat(encodeURIComponent(Base64.encode(url)));
    } // download(url) {
    //   console.log('AutoConsole: download -> url', url)
    //   download(url, this.showName(url))
    // }
  },
  created: function created() {
    var _this2 = this;
    getKnowledgeDocDetail({
      id: ~~this.id
    }).then(function (res) {
      if (res.success) {
        _this2.info = res.data;
      } else {
        _this2.$vux.toast.text(res.message);
      }
    });
  }
};